const showHide = (element, eventHandlers) => {
    let elementClick = false;
    element.classList.add('hide');

    let blockEvents = false;
    let elementFirstClick = true;

    element.addEventListener('mousedown', (e) => {
        e.stopPropagation();
        if (document.activeElement.parentNode.className.indexOf('search__input') !== -1) {
            elementClick = true;
        }
        
    });

    const blockPreceedingEvents = (time) => {
        blockEvents = true;
        setTimeout(() => {
            blockEvents = false;
        }, time);
    }

    eventHandlers.show = () => {
        if (!blockEvents) {
            element.classList.remove('hide');
            window.addEventListener('click', eventHandlers.hide);
        }
    };
    eventHandlers.hide = (e, sa) => {
        if (!blockEvents && !elementClick) {
            element.classList.add('hide');
            window.removeEventListener('click', eventHandlers.hide);
        }
        elementFirstClick = true;
        elementClick = false;
    };

    return {
        blockEvents: blockPreceedingEvents,
        show: eventHandlers.show,
        hide: eventHandlers.hide
    }
}
